import { render, staticRenderFns } from "./EngineerPeople.vue?vue&type=template&id=0ac5a72c&"
import script from "./EngineerPeople.vue?vue&type=script&lang=js&"
export * from "./EngineerPeople.vue?vue&type=script&lang=js&"
import style0 from "./EngineerPeople.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports